import React, {
  useState,
  useContext,
  createContext,
  ReactElement,
  Dispatch,
  SetStateAction,
  useRef,
  useCallback,
} from 'react';
import { VIDEO_PREVIEW_DEFAULT, VideoPreviewProps } from '../constants/dashboardDiscoverMode';

interface UseDashboardDiscoverModeProps {
  videoPreview: VideoPreviewProps;
  setVideoPreview: Dispatch<SetStateAction<VideoPreviewProps>>;
  offerActionContainerRef: any;
  photoAspectRatioRef: any;
  discoverActiveAccount: any;
  setDiscoverActiveAccount: Dispatch<SetStateAction<any>>;
  animateDirection: string;
  setAnimateDirection: Dispatch<SetStateAction<string>>;
  isDotsAnimated: boolean;
  setIsDotsAnimated: Dispatch<SetStateAction<boolean>>;
  calculateHeightPhotoSlider: () => void;
  discoverCardMediaRatio: string;
}

const DashboardDiscoverContext = createContext({});

const DashboardDiscoveModeProvider = (props: any): ReactElement => {
  const [videoPreview, setVideoPreview] = useState(VIDEO_PREVIEW_DEFAULT);
  const offerActionContainerRef = useRef(null);
  const photoAspectRatioRef = useRef(null);
  const [discoverActiveAccount, setDiscoverActiveAccount] = useState(null);
  const [animateDirection, setAnimateDirection] = useState('');
  const [isDotsAnimated, setIsDotsAnimated] = useState(false);
  const [discoverCardMediaRatio, setDiscoverCardMediaRatio] = useState('133%'); // Default value

  const calculateHeightPhotoSlider = useCallback(() => {
    const photoAspectEl = photoAspectRatioRef?.current;
    const offerActionEl = offerActionContainerRef?.current;

    if (photoAspectEl && offerActionEl) {
      const offerActionClRec = offerActionEl.getBoundingClientRect();
      const photoAspectClRec = photoAspectEl.getBoundingClientRect();

      const topValue = Math.max(photoAspectClRec.top, 66);

      const PHOTO_SLIDER_COUNTER_HEIGHT = 41;
      const PHOTO_SLIDER_MARGIN_BOTTOM = 15;
      const dynamicPaddingTop =
        offerActionClRec.top - topValue - PHOTO_SLIDER_COUNTER_HEIGHT - PHOTO_SLIDER_MARGIN_BOTTOM;

      setDiscoverCardMediaRatio(`${dynamicPaddingTop}px`);
    }
  }, [offerActionContainerRef?.current, photoAspectRatioRef?.current]);

  const values: UseDashboardDiscoverModeProps = {
    videoPreview,
    setVideoPreview,
    offerActionContainerRef,
    photoAspectRatioRef,
    discoverActiveAccount,
    setDiscoverActiveAccount,
    animateDirection,
    setAnimateDirection,
    isDotsAnimated,
    setIsDotsAnimated,
    calculateHeightPhotoSlider,
    discoverCardMediaRatio,
  };

  return <DashboardDiscoverContext.Provider value={values} {...props} />;
};

const useDashboardDiscoverMode = (): UseDashboardDiscoverModeProps =>
  useContext(DashboardDiscoverContext) as UseDashboardDiscoverModeProps;

export { DashboardDiscoveModeProvider, useDashboardDiscoverMode };
